import type { AttachmentFile } from "./AttachmentFile";

export enum DynamicFieldType {
  multilineText = "multiline_text",
  text = "text",
  datetimeLocal = "datetime-local",
  date = "date",
  number = "number",
  select = "select",
  checkbox = "checkbox",
  fileUpload = "file_upload",
}

export type FieldTypeValueMap = {
  [DynamicFieldType.text]: string;
  [DynamicFieldType.multilineText]: string;
  [DynamicFieldType.select]: string;
  [DynamicFieldType.checkbox]: string;
  [DynamicFieldType.number]: string;
  [DynamicFieldType.date]: string;
  [DynamicFieldType.datetimeLocal]: string;
  [DynamicFieldType.fileUpload]: AttachmentFile[];
};
